import React from 'react';
import TopicStatusBar from './TopicStatusBar';
import { TopicStatus } from '../../../../services/types/Toolkit';

interface Props {
  topicTitle: string;
  status: TopicStatus;
}

const TopicRow = (props: Props) => {
  const { topicTitle, status } = props;
  return (
    // <table className="topic-table">
    //   <tbody>
    //     <tr>
    //       <td>{topicTitle}</td>
    //       <td className="status">
    //         <TopicStatusBar status={status} />
    //       </td>
    //     </tr>
    //   </tbody>
    // </table>
    <div className="topic-row">
      <div className="topic-row__title">{topicTitle}</div>
      <div className="topic-row__status">
        <TopicStatusBar status={status} />
      </div>
    </div>
  );
};

export default TopicRow;
